import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';


@Component({
    selector: 'app-kb-choose-file',
    template: `
  <div id="warranty-submit-block0" class="warranty-submit-upload">
    <div class="popup-upload-headline popup-upload-title">
      <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
      <button mat-dialog-close class="btn btn-link upload-close"></button>
    </div>
    <mat-dialog-content>
      <div class="popup-upload-body">
        <p class="attach-body-heading">
          {{ 'common.text_warranty_select_file_wish' | cxTranslate }}
        </p>
        <div class="popup-upload-wrapper files" id="files0">
          <input type="hidden" class="hiddenLoopIndex" value="0">
          @if (isUploadfileSuccess) {
            <div class="popup-alert-msg files-success-alert">
              <img src="/assets/images/info-green.svg" alt="File upload success">
              <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
            </div>
          }
          @if (isMaxFileSize) {
            <div class="popup-alert-msg files-danger-alert">
              <img src="/assets/images/info-red.svg" alt="File Max Size Error"><span class="text">
              {{ 'common.text_select_you_can_upload' | cxTranslate }}
            </span>
          </div>
        }
        @if (isDuplicateFile) {
          <div class="popup-alert-msg files-danger-alert-duplicate">
            <img src="/assets/images/info-red.svg" alt="File Duplicate error">
            <span class="text">
              {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
            </span>
          </div>
        }
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <input type="file"  #file (input)="fileSelector(file)"
              accept=".doc, .docx, .xls, .xlsx, .csv, .txt, .tif, .gif, .jpg, .pdf, image/*, .HTML"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
              <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
                (click)="fileUploadFunction()" type="button"
                [disabled]="isAtleastOnefileIsThere">
                {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="warranty-upload-note">
            {{ 'common.text_select_file_type_upload' | cxTranslate }}<br>
          </div>
          <div class="popup-upload-fileLists">
            @if (fileLength$|async; as filecount ) {
              <div class="upload-fileList-result">
                {{ 'common.text_select_you_record_sets' | cxTranslate }}
                <span class="upload-fileList-result-number">{{ filecount }}</span>
              </div>
            } @else {
              <div class="upload-fileList-result">
                {{ 'common.text_select_you_record_sets' | cxTranslate }}
                <span class="upload-fileList-result-number">0</span>
              </div>
            }
            <ul>
              <li class="hidden-xs hidden-sm">
                <ul class="item__list--header">
                  <li class="item__sort">#</li>
                  <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                  <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                  <li class="item__remove"></li>
                </ul>
              </li>
              <li class="item__list--item js-li-container upload-block">
                @if (fileCurrentFiles$|async; as currentFiles) {
                  @for (file of currentFiles; track file; let i = $index) {
                    <ul class="fileList">
                      <li>
                        <div class="item__sort_tr">{{i+1}}</div>
                        <div class="item__name_tr">{{currentFiles[i].name}}</div>
                        <div class="item__size_tr">{{currentFiles[i].size | number : '1.2-2'}}&nbsp;KB
                        </div>
                        <div class="removeFile_tr"><button class="btn btn-link btn-remove"
                          (click)="removefile(file)">{{
                          'common.text_remove' | cxTranslate
                        }}</button></div>
                      </li>
                    </ul>
                  }
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>
  `,
    styleUrls: ['./kbBrakeApllicationForms-module.component.scss'],
    standalone: false
})
export class BrakeAppChooseFileDialog {
    fileService = inject(KbFileService);
    isDuplicateFile: boolean = false;
    isMaxFileSize: boolean = false;
    isUploadfileSuccess: boolean = false;
    isAtleastOnefileIsThere: boolean = true;
    productNotFound = undefined;

    fileLength$: Observable<any> = this.fileService.getCurrentFileCount();
    fileCurrentFiles$: Observable<any> = this.fileService.getCurrentFilesInfo();
    private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
    fileSelector(event: any) {
        const files = Object.values(event.files);
        const TotalFileSizeExceeds = this.fileService.isTotalFileSizeLessThan9MB();

        files.map((file: File) => {
            if ((!this.fileService.isFileSizeLessThan9MB(file)) || !TotalFileSizeExceeds) {
                this.isMaxFileSize = true;
                // event.value = '';
            }
            else if (!this.fileService.isNotDuplicate(file.name)) {
                this.isDuplicateFile = true;
                // event.value = '';
            }
            else {
                this.fileService.addFile(file);
                this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
                // event.value = '';
            }
        });


        this.timeout = setTimeout(() => {
            this.isDuplicateFile = false;
            this.isMaxFileSize = false;
            this.isUploadfileSuccess = false;
        }, 7000);

    }
    removefile(file: File) {
        this.fileService.deleteFile(file.name);
        this.isAtleastOnefileIsThere = !this.fileService.isAtLeastOneFilePresent();
    }

    fileUploadFunction() {
        this.isAtleastOnefileIsThere = this.fileService.isAtLeastOneFilePresent();
        if (this.isAtleastOnefileIsThere) {
            this.isUploadfileSuccess = true;
        }
        this.timeout = setTimeout(() => {
            this.isUploadfileSuccess = false;
        }, 7000);
        const file = this.fileService.getAllFiles();
    }
    ngOnDestroy(): void {
        // Unsubscribe from the scroll event
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }


}
